import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { SalesPage } from "./pages/SalesPage";
type AppProps = {
  showPurchasePopup?: boolean;
};
export function App({
  showPurchasePopup = true
}: AppProps) {
  return <>
      <MetaPixel data-id="element-0" data-mp="3k92qy7wdoeph" />
      <SalesPage showPurchasePopup={showPurchasePopup} data-id="element-1" data-mp="3k7i3t3ce7y1n" />
    </>;
}